const getIsRcpSubscriptionCreationPending = (subscription: Subscription): boolean => {
  return subscription?.rcp && !subscription?.rcp?.cluster?.url;
};

export default getIsRcpSubscriptionCreationPending;
